<div class="list-group" *ngIf="sortedPages">

    <!-- First page link if needed-->
    <a href="#" class="card my-1 list-group-item-action"
        (click)="selectPage(1)"
        *ngIf="!hasFirst">
        <div class="card-body">
            <span class="small text-muted">{{ 'msg#preview.page' | sqMessage:{values:{page: 1} } }}</span>
            <div class="text-center my-3" *ngIf="_pendingPage === 1">
                <div class="spinner-grow" role="status"></div>
            </div>
        </div>
    </a>

    <!-- For each page in the document -->
    <ng-container *ngFor="let page of sortedPages">

        <!-- Link to page other than current -->
        <a href="#" class="card my-1 list-group-item-action"
            (click)="selectPage(page.$page)"
            *ngIf="currentPage !== page.$page">
            <div class="card-body" >
                <span class="small text-muted">{{ 'msg#preview.page' | sqMessage:{values:{page: page.$page} } }}</span>
                <p [innerHTML]="page.relevantExtracts" *ngIf="_pendingPage !== page.$page"></p>
                <div class="text-center my-3" *ngIf="_pendingPage === page.$page">
                    <div class="spinner-grow" role="status"></div>
                </div>
            </div>
        </a>

        <!-- For current page we display extracts -->
        <ng-container *ngIf="currentPage === page.$page">
            <a href="#" class="card my-1 list-group-item-action"
                *ngIf="!hasPrevious"
                (click)="selectPrevious()">
                <div class="card-body">
                    <span class="small text-muted">{{ 'msg#preview.page' | sqMessage:{values:{page: currentPage - 1} } }} ({{ 'msg#preview.previousDocument' | sqMessage }})</span>
                    <div class="text-center my-3" *ngIf="_pendingPage === currentPage - 1">
                        <div class="spinner-grow" role="status"></div>
                    </div>
                </div>
            </a>
            <div class="card my-1" #currentPageEl>
                <div class="card-body m-0">
                    <span class="small fw-bold mb-1">{{ 'msg#preview.page' | sqMessage:{values:{page: currentPage} } }} ({{ 'msg#preview.current' | sqMessage }})</span>
                    <sq-preview-extracts-panel 
                        *ngIf="!_pendingPreviewDocument" 
                        class="d-flex flex-column"
                        style="height: 300px;"
                        [previewData]="previewData"
                        [previewDocument]="previewDocument"
                        [style]="style">
                    </sq-preview-extracts-panel>
                </div>
            </div>
            <a href="#" class="card my-1 list-group-item-action"
                *ngIf="!hasNext"
                (click)="selectNext()">
                <div class="card-body">
                    <span class="small text-muted">{{ 'msg#preview.page' | sqMessage:{values:{page: currentPage + 1} } }} ({{ 'msg#preview.nextDocument' | sqMessage }})</span>
                    <div class="text-center my-3" *ngIf="_pendingPage === currentPage + 1">
                        <div class="spinner-grow" role="status"></div>
                    </div>
                </div>
            </a>
        </ng-container>

    </ng-container>
</div>